import {
    GET_CAPITAL_GOODS_AND_SERVICES_DATA_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_DATA_FAIL,
    POST_CAPITAL_GOODS_AND_SERVICES_DATA_SUCCESS,
    POST_CAPITAL_GOODS_AND_SERVICES_DATA_FAIL,
    GET_CAPITAL_GOODS_AND_SERVICES_DATA_TOTALS_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_DATA_TOTALS_FAIL
} from '../../../actions/carbonfootprint-rework/types/04-indirect-ghg-emissions-from-products-used-by-an-organisation';

const initialState = {
    loading: true,
    capitalGoodsAndServicesData: [],
    capitalGoodsAndServicesDataTotals: []
};

export default function indirectGhgEmissionsFromProductsForCapitalGoodsAndServicesReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case POST_CAPITAL_GOODS_AND_SERVICES_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_CAPITAL_GOODS_AND_SERVICES_DATA_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_DATA_SUCCESS:
            return {
                ...state,
                capitalGoodsAndServicesData: payload,
                loading: false,
            };
        case GET_CAPITAL_GOODS_AND_SERVICES_DATA_FAIL:
            return {
                ...state,
                capitalGoodsAndServicesData: payload,
                loading: false
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_DATA_TOTALS_SUCCESS:
            return {
                ...state,
                capitalGoodsAndServicesDataTotals: payload,
                loading: false,
            };
        case GET_CAPITAL_GOODS_AND_SERVICES_DATA_TOTALS_FAIL:
            return {
                ...state,
                capitalGoodsAndServicesDataTotals: payload,
                loading: false
            }
        default:
            return state;
    }
}